



































































































import { Component, Vue } from 'vue-property-decorator'
import { GetterCart, MutationCart } from '@/store/cart'
import { ProductItem } from '@/store/product'
import { DialogEntry, MutationDialog } from '@/store/dialog'
import { MutationSnackbar, SnackbarEntry } from '@/store/snackbar'

@Component
export default class Panier extends Vue {
  @GetterCart
  selectedItems: ProductItem[]

  @MutationCart
  setSelectedItems: ProductItem[]

  @MutationCart
  setItemsArray: ProductItem[]

  @MutationDialog
  setDialogEntry: (entry: DialogEntry) => void

  @MutationSnackbar
  setSnackbarEntry: (entry: SnackbarEntry) => void

  headers: any[] = [
    { text: 'Article(s)', align: 'left', value: 'titre', sortable: true },
    { text: 'Prix unitaire', align: 'center', value: 'prix', sortable: true },
    { text: 'Quantité', align: 'center', value: 'quantite', sortable: false },
    { text: 'Prix total', align: 'center', value: 'montant', sortable: false },
    { text: 'Suppr', align: 'center', value: 'icon', sortable: false }
  ]

  get indexedItems () {
    return this.selectedItems.map((item, index) => ({
      id: index,
      ...item
    }))
  }

  get montantTotal () {
    return this.selectedItems.reduce((acc, item) => (!item.prix) ? acc : acc + item.prix * item.quantite, 0)
  }

  get montantReduction () {
    return this.selectedItems.reduce((acc, item) => (!item.prixOld || !item.prix) ? acc : acc + (item.prixOld - item.prix) * item.quantite, 0)
  }

  deleteProduct (product?: ProductItem, i?: number) {
    if (product && i) {
      this.setDialogEntry({
        message: `Etes-vous certain de vouloir supprimer cet ou les article(s) "${product.titre}" ?`,
        title: `Supprimer le ou les article(s)`,
        trueandfalse: true,
        onOk: () => this.agreeDelete(i),
        okLabel: 'Ok',
        cancelLabel: 'Annuler'
      })
    }
  }

  deletePanier () {
    this.setDialogEntry({
      message: `Vous souhaitez annuler votre commande. Merci de confirmer cette annulation.`,
      title: `Annulation de commande`,
      trueandfalse: true,
      onOk: () => this.deleteAllCart(),
      okLabel: 'Ok',
      cancelLabel: 'Annuler'
    })
  }

  deleteAllCart () {
    console.log('deleteAllCart')
    // let arrayData: ProductItem[] = []
    this.setItemsArray = []
  }

  agreeDelete (i: number) {
    try {
      // Rafraichissement des données concernées
      const data = this.selectedItems
      data.splice(i, 1)
      if (data.length > 0) {
        this.setItemsArray = data
      } else {
        this.setItemsArray = []
        console.log(this.selectedItems)
      }

    } catch (err) {
      const response = err.response
      if (response) {
        err.__handled__ = true
        // this.failed = true
        if (response) {
          // this.statusText = response.statusText
          // this.status = response.status
          // this.messageText = response.data.message
          // this.titleText = 'Suppression Impossible'
          // if (this.failed) {
          //   this.messageText = 'Une erreur inconnue s\'est produite'
          // }
          this.setSnackbarEntry({
            icon: 'mdi-alert-circle',
            color: 'error'
            // ,
            // title: this.titleText,
            // message: this.messageText
          })
        }
      }
      throw err
    }
  }
}
